var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16994 11.0002C0.983692 10.8128 0.879151 10.5594 0.879151 10.2952C0.879151 10.031 0.983692 9.77756 1.16994 9.59019L4.70994 6.00019L1.16994 2.46019C0.983692 2.27283 0.87915 2.01938 0.87915 1.75519C0.87915 1.49101 0.983692 1.23756 1.16994 1.05019C1.26291 0.956464 1.37351 0.88207 1.49537 0.831301C1.61723 0.780533 1.74793 0.754395 1.87994 0.754395C2.01195 0.754395 2.14266 0.780533 2.26452 0.831301C2.38638 0.88207 2.49698 0.956464 2.58994 1.05019L6.82994 5.29019C6.92367 5.38316 6.99807 5.49376 7.04883 5.61562C7.0996 5.73747 7.12574 5.86818 7.12574 6.00019C7.12574 6.1322 7.0996 6.26291 7.04883 6.38477C6.99807 6.50663 6.92367 6.61723 6.82994 6.71019L2.58994 11.0002C2.49698 11.0939 2.38638 11.1683 2.26452 11.2191C2.14266 11.2699 2.01195 11.296 1.87994 11.296C1.74793 11.296 1.61723 11.2699 1.49537 11.2191C1.37351 11.1683 1.26291 11.0939 1.16994 11.0002Z",
    fill: "#54565A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.49c6610951135ebcd65d87af1c071b51.svg";
export { ForwardRef as ReactComponent };